import React from "react";
import { GoalToggleButton } from "./goal-toggle-button";
import { MetricBar } from "./metric-bar";
import { metricPace } from "./pace";

interface MetricCardContent {
    label: string;
    barColor: string;
    actual: number;
    target: number;
    frac: number;
    footer: React.ReactNode;
}

const MetricCardBody: React.FC<MetricCardContent> = ({
    label,
    barColor,
    actual,
    target,
    frac,
    footer,
}) => {
    const pace = metricPace(actual, target, frac);
    const pct = target > 0 ? Math.round((actual / target) * 100) : null;
    return (
        <>
            <div className="flex items-center gap-2">
                <span className={`inline-block size-2.5 rounded-sm ${barColor}`} />
                <span className="text-[12.5px] font-semibold text-zinc-800">{label}</span>
                <span className="ml-auto inline-flex items-center gap-1 text-[11px] font-semibold">
                    <span className={`size-1.5 rounded-full ${pace.dot}`} />
                    <span className={pace.text}>{pace.label}</span>
                </span>
            </div>
            <div className="mt-2 flex items-baseline gap-1.5">
                <span className="text-[26px] font-bold leading-none tabular-nums text-zinc-950">
                    {actual}
                </span>
                <span className="text-sm text-gray-500">/ {target || "—"}</span>
                {pct !== null ? (
                    <span className="ml-auto inline-flex items-baseline gap-1">
                        <span className="text-[13px] font-bold tabular-nums text-zinc-900">
                            {pct}%
                        </span>
                        <span className="text-[11px] font-normal text-gray-500">
                            complete
                        </span>
                    </span>
                ) : null}
            </div>
            <div className="mt-2.5">
                <MetricBar
                    actual={actual}
                    target={target}
                    bar={barColor}
                    frac={frac}
                    height="h-2"
                />
            </div>
            <div className="mt-2 text-[11px] text-gray-500">{footer}</div>
        </>
    );
};

interface MetricFilterCardProps extends MetricCardContent {
    selected: boolean;
    onToggle: () => void;
}

export const MetricFilterCard: React.FC<MetricFilterCardProps> = ({
    selected,
    onToggle,
    ...content
}) => (
    <GoalToggleButton
        selected={selected}
        onToggle={onToggle}
        className="w-full rounded-xl px-4 py-3.5 shadow-sm">
        <MetricCardBody {...content} />
    </GoalToggleButton>
);
